export default num => num.replace(/^(\d{5})/, '$1 ');



// WEBPACK FOOTER //
// ./src/Common/formatPhoneNumber/index.js